import { useState } from 'react';
import type { DragEvent, FC } from 'react';
import { Button } from '../../ui/Button/Button';
import { IconCheck, IconSpinner, IconTable, IconUpload } from '../../../assets/icons/icons';
import { UPLOAD_LIMITS } from '../../../data/projectCard';
import { cx } from '../../../utils/cx';
import styles from './Dropzone.module.scss';
import React from 'react';

interface DropzoneProps {
    state: 'empty' | 'loading' | 'success';
    fileName?: string;
    title?: string;
    hint?: string;
    formats?: string;
    accept?: string;
    onPickFile?: () => void;
    onAddManually?: () => void;
    onDropFile?: (file: File) => void;
}

export const Dropzone: FC<DropzoneProps> = ({
    state,
    fileName,
    title,
    hint,
    formats,
    onPickFile,
    onAddManually,
    onDropFile,
}) => {
    const [dragging, setDragging] = useState(false);

    if (state === 'loading') {
        return (
            <div className={styles.dropzone}>
                <div className={styles.icon}>
                    <IconSpinner className={styles.spin} />
                </div>
                <b>Обрабатываем заявку</b>
                <p>Разбираем структуру файла и сопоставляем колонки с полями проекта.</p>
            </div>
        );
    }

    if (state === 'success') {
        return (
            <div className={cx(styles.dropzone, styles.success)}>
                <div className={styles.icon}>
                    <IconCheck />
                </div>
                <b>Заявка загружена</b>
                <p>{fileName} — обрабатываем файл, позиции появятся в списке.</p>
                <div className={styles.formats}>{UPLOAD_LIMITS.hint}</div>
            </div>
        );
    }

    const stop = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <div
            className={cx(styles.dropzone, dragging && styles.drag)}
            onDragEnter={(event) => {
                stop(event);
                setDragging(true);
            }}
            onDragOver={(event) => {
                stop(event);
                setDragging(true);
            }}
            onDragLeave={(event) => {
                stop(event);
                setDragging(false);
            }}
            onDrop={(event) => {
                stop(event);
                setDragging(false);
                const file = event.dataTransfer.files[0];
                if (file) onDropFile?.(file);
            }}
        >
            <div className={styles.icon}>
                <IconUpload />
            </div>
            <b>{title ?? 'Перетащите файл заявки'}</b>
            <p>
                {hint ??
                    'Система разберёт таблицу и подставит позиции. Поиск не начнётся, пока вы его не запустите.'}
            </p>
            <div className={styles.actions}>
                <Button variant="primary" onClick={onPickFile}>
                    Выбрать файл
                </Button>
                {onAddManually && (
                    <Button icon={<IconTable />} onClick={onAddManually}>
                        Заполнить вручную
                    </Button>
                )}
            </div>
            <div className={styles.formats}>{UPLOAD_LIMITS.short}</div>
        </div>
    );
};